import {Icon} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

interface CellDimensionAttrs {
    weight?: number | string | null
    length?: number | string | null
    height?: number | string | null
    width?: number | string | null

    cases_per_pallet?: number | null | undefined
    cases_per_pallet_layer?: number | null | undefined
}

export class CellDimension extends MithrilComponent<CellDimensionAttrs> {
    view(vnode: m.Vnode<CellDimensionAttrs>) {
        const children: m.ChildArray = []
        if (vnode.attrs.weight) {
            children.push(
                <div className='dimension-info'>
                    <Icon name='weight' size='xs' />
                    <div className='stat'>{vnode.attrs.weight} kg</div>
                </div>,
            )
        }
        if (Number(vnode.attrs.length ?? 0) > 0 || vnode.attrs.height || vnode.attrs.width) {
            children.push(
                <div className='dimension-info'>
                    <Icon name='case' size='xs' />
                    <div className='stat'>
                        {`${vnode.attrs.length ?? 0} x ${vnode.attrs.width ?? 0} x ${vnode.attrs.height ?? 0}`}
                    </div>
                </div>,
            )
        }
        if (vnode.attrs.cases_per_pallet || vnode.attrs.cases_per_pallet_layer) {
            children.push(
                <div className='dimension-info'>
                    <Icon name='cpp' size='xs' />
                    <div className='stat'>
                        {typeof vnode.attrs.cases_per_pallet === 'number' && <span>{`${vnode.attrs.cases_per_pallet} cpp`}</span>}
                        {vnode.attrs.cases_per_pallet_layer && <span>{`${vnode.attrs.cases_per_pallet_layer} cpl`}</span>}
                    </div>
                </div>,
            )
        }
        return <div className='c-cell-dimension td-group'>{children}</div>
    }
}
